import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function PackPresentation() {
  return <section className="py-24 px-4 bg-[#5A7D60] text-white relative overflow-hidden" data-id="element-156">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-157">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-158">
          <pattern id="leaf-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-159">
            <path d="M20 0C15 5 15 15 20 20C25 15 25 5 20 0Z" fill="currentColor" data-id="element-160" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#leaf-pattern)" data-id="element-161" />
        </svg>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-163">
          <span className="inline-block px-4 py-1 rounded-full bg-white/20 text-white text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-164">
            La Solución Integral
          </span>

          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-id="element-165">
            Pack Completo de 10 E-books para
            <br data-id="element-166" />
            <span className="italic opacity-90" data-id="element-167">
              Madres y Padres Conscientes
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-10 font-light" data-id="element-168">
            Una biblioteca digital diseñada para darte respuestas rápidas,
            efectivas y respetuosas a los 10 desafíos más comunes de la crianza.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-12 text-white/90" data-id="element-169">
            {['100% Digital', 'Acceso Inmediato', 'Lectura Ágil', 'Métodos Respetuosos'].map(feature => <div key={feature} className="flex items-center gap-2" data-id="element-170">
                <div className="bg-white/20 p-1 rounded-full" data-id="element-171">
                  <Check size={14} data-id="element-172" />
                </div>
                <span data-id="element-173">{feature}</span>
              </div>)}
          </div>

          <Button size="lg" className="bg-white text-[#5A7D60] hover:bg-white/90 shadow-xl" data-id="element-174">
            Quiero transformar mi crianza hoy
          </Button>
        </motion.div>
      </div>
    </section>;
}